module.exports = {"511424102":"仁美镇","511424105":"丹棱镇","511424106":"杨场镇","511424107":"双桥镇","511424108":"张场镇","511424200":"石桥乡","511424204":"顺龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511424.json
// module id = 2170
// module chunks = 0